import logger             from '../../../../Shared/Util/logger';
import PLAYER_STORAGE_KEY from '../Constants/playerStorageKey';
import ILocalStorage      from '../Interfaces/ILocalStorage';

const readLocalStorage = (): ILocalStorage => {
    const contents: ILocalStorage = {};

    try {
        Object.assign(contents, JSON.parse(window.localStorage.getItem(PLAYER_STORAGE_KEY)));
    } catch (err) {
        logger.error(err);
    }

    return contents;
};

export default readLocalStorage;